export { default } from '@rsos/base-components/Text';
